import axios from "axios";
import {
  LOADING_REQUEST,
  LOADING_SUCCESS,
} from "../Constants/LoadingConstants";

import {
  SAMPLE_ADD_REQUEST,
  SAMPLE_ADD_SUCCESS,
  SAMPLE_ADD_FAIL,
  SAMPLE_LIST_REQUEST,
  SAMPLE_LIST_SUCCESS,
  SAMPLE_LIST_FAIL,
  SAMPLE_PARTICULAR_SUCCESS,
  SAMPLE_PARTICULAR_FAILED,
  SAMPLE_EDIT_SUCCESS,
  SAMPLE_EDIT_FAIL,
  SAMPLE_DELETE_SUCCESS,
  SAMPLE_DELETE_FAIL,
  SAMPLE_PREVIEW_REQUEST,
  SAMPLE_PREVIEW_SUCCESS,
  SAMPLE_PREVIEW_FAIL,
  SAMPLE_GENERATE_SUCCESS,
  SAMPLE_GENERATE_FAIL,
  SAMPLE_COUNT_SUCCESS,
  SAMPLE_COUNT_FAILED,
  GETEXPERIENCE_SUCCESS,
  GETEXPERIENCE_FAIL,
  COVER_SAMPLE_LIST_REQUEST,
  COVER_SAMPLE_LIST_SUCCESS,
  COVER_SAMPLE_LIST_FAIL,
} from "../Constants/SampleConstatns";

import {
  SAMPLE_ACHIEVEMENTS_ADD,
  SAMPLE_EDUCATION_ADD,
  SAMPLE_INTEREST_ADD,
  SAMPLE_LANGUAGES_ADD,
  POSITION_CHANGE,
  SAMPLE_PROFILE_ADD,
  SAMPLE_SKILLS_ADD,
  SAMPLE_SUMMARY_ADD,
  SAMPLE_WORK_EXPERIENCE_ADD,
  SAMPLE_POSITION_ADD,
  SAMPLE_CUSTOM_DATE_SECTION_ADD,
  SAMPLE_CUSTOM_TEXT_SECTION_ADD,
  SAMPLE_COLORCHANGE_ADD,
} from "../Constants/EditorConstants";

import {
  COLORCHANGE_SUCCESS,
  SAMPLE_COLORCHANGE_SUCCESS,
} from "../Constants/CustomizationConstants";

const baseUrl = process.env.REACT_APP_API_URL;

export const coverSampleList =
  (id, exp, particularId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: LOADING_REQUEST,
        loading: true,
      });
      dispatch({
        type: COVER_SAMPLE_LIST_REQUEST,
        loading: true,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${adminInfo.token}`
        },
      };
      if (id && id == "admin") {
        const { data } = await axios.get(
          `${baseUrl}/api/samples/cover/admin`,
          config
        );
        dispatch({
          type: COVER_SAMPLE_LIST_SUCCESS,
          payload: data,
        });
        dispatch({
          type: LOADING_REQUEST,
          loading: false,
        });
      } else {
        if (exp == "sort") {
          const { data } = await axios.get(
            `${baseUrl}/api/sample/cover/sort/${id}`,
            config
          );
          dispatch({
            type: COVER_SAMPLE_LIST_SUCCESS,
            payload: data,
          });
          dispatch({
            type: LOADING_REQUEST,
            loading: false,
          });
        } else if (exp) {
          const { data } = await axios.get(
            `${baseUrl}/api/sample/cover/sort/${id}/${exp}`,
            config
          );
          dispatch({
            type: COVER_SAMPLE_LIST_SUCCESS,
            payload: data,
          });
          dispatch({
            type: LOADING_REQUEST,
            loading: false,
          });
        }
        // `	else if (type) {
        // 		const { data } = await axios.get(`${baseUrl}/api/sample/sort/?sort=${id}`, config)
        // 		dispatch({
        // 			type: SAMPLE_LIST_SUCCESS,
        // 			payload: data,
        // 		})
        // 		dispatch({
        // 			type: LOADING_REQUEST,
        // 			loading: false
        // 		});
        // 	}`
        else if (id && id != "") {
          const { data } = await axios.get(
            `${baseUrl}/api/samples/cover/${id}`,
            config
          );
          dispatch({
            type: COVER_SAMPLE_LIST_SUCCESS,
            payload: data,
          });
          dispatch({
            type: LOADING_REQUEST,
            loading: false,
          });
        } else {
          const { data } = await axios.get(
            `${baseUrl}/api/samples/cover/All`,
            config
          );
          dispatch({
            type: COVER_SAMPLE_LIST_SUCCESS,
            payload: data,
          });
          dispatch({
            type: LOADING_REQUEST,
            loading: false,
          });
        }
        dispatch({
          type: LOADING_REQUEST,
          loading: false,
        });
      }
    } catch (error) {
      dispatch({
        type: COVER_SAMPLE_LIST_FAIL,
        payload:
          error.response && error.response.data
            ? error.response.data
            : error.message,
      });
      dispatch({
        type: LOADING_REQUEST,
        loading: false,
      });
    }
  };

export const sampleList = (id, exp) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING_REQUEST,
      loading: true,
    });
    dispatch({
      type: SAMPLE_LIST_REQUEST,
      loading: true,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${adminInfo.token}`
      },
    };
    if (id && id == "admin") {
      const { data } = await axios.get(`${baseUrl}/api/samples/admin`, config);
      dispatch({
        type: SAMPLE_LIST_SUCCESS,
        payload: data,
      });
      dispatch({
        type: LOADING_REQUEST,
        loading: false,
      });
    } else {
      if (exp == "sort") {
        const { data } = await axios.get(
          `${baseUrl}/api/sample/sort/${id}`,
          config
        );
        dispatch({
          type: SAMPLE_LIST_SUCCESS,
          payload: data,
        });
        dispatch({
          type: LOADING_REQUEST,
          loading: false,
        });
      } else if (exp) {
        const { data } = await axios.get(
          `${baseUrl}/api/sample/sort/${id}/${exp}`,
          config
        );
        dispatch({
          type: SAMPLE_LIST_SUCCESS,
          payload: data,
        });
        dispatch({
          type: LOADING_REQUEST,
          loading: false,
        });
      }
      // `	else if (type) {
      // 		const { data } = await axios.get(`${baseUrl}/api/sample/sort/?sort=${id}`, config)
      // 		dispatch({
      // 			type: SAMPLE_LIST_SUCCESS,
      // 			payload: data,
      // 		})
      // 		dispatch({
      // 			type: LOADING_REQUEST,
      // 			loading: false
      // 		});
      // 	}`
      else if (id && id != "") {
        const { data } = await axios.get(
          `${baseUrl}/api/samples/${id}`,
          config
        );
        dispatch({
          type: SAMPLE_LIST_SUCCESS,
          payload: data,
        });
        dispatch({
          type: LOADING_REQUEST,
          loading: false,
        });
      } else {
        const { data } = await axios.get(`${baseUrl}/api/samples/All`, config);
        dispatch({
          type: SAMPLE_LIST_SUCCESS,
          payload: data,
        });
        dispatch({
          type: LOADING_REQUEST,
          loading: false,
        });
      }
      dispatch({
        type: LOADING_REQUEST,
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: SAMPLE_LIST_FAIL,
      payload:
        error.response && error.response.data
          ? error.response.data
          : error.message,
    });
    dispatch({
      type: LOADING_REQUEST,
      loading: false,
    });
  }
};

export const sampleCountAdd = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING_REQUEST,
      loading: true,
    });

    const {
      userData: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.put(
      `${baseUrl}/api/sample/count/${id}`,
      {},
      config
    );

    dispatch({
      type: SAMPLE_COUNT_SUCCESS,
      payload: data,
    });
    dispatch({
      type: LOADING_SUCCESS,
      loading: false,
    });
  } catch (error) {
    dispatch({
      type: LOADING_SUCCESS,
      loading: false,
    });
    dispatch({
      type: SAMPLE_COUNT_FAILED,
      payload:
        error.response && error.response.data
          ? error.response.data.error
          : error.message,
    });
  }
};
